import React from 'react';
import Svg from 'react-native-svg';
const AsForwarderTemp = ({
  as,
  children,
  ...props
}) => {
  const As = as;
  return as ? /*#__PURE__*/React.createElement(As, props, children) : /*#__PURE__*/React.createElement(Svg, props, children);
};
AsForwarderTemp.displayName = '__AsForwarder__';
export const AsForwarder = AsForwarderTemp;
//# sourceMappingURL=AsForwarder.js.map